import React from 'react';
import Col from 'react-bootstrap/Col';
// import style from './PageTitle.module.scss';

interface PageTitleProps {
  // add page title props here
  children: React.ReactNode;
  className?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}

const PageTitle: React.FC<PageTitleProps> = ({
  children,
  className,
  level,
}: PageTitleProps) => {
  const tagClass = level ? 'h1' : '';

  /* this is the dumbest, most repetative workaround.
   *   Scout's orignal solution doesn't pass enzyme's test.
   */
  let heading: React.ReactNode = <h1 className={tagClass}>{children}</h1>;

  switch (level) {
    case 2:
      heading = <h2 className={tagClass}>{children}</h2>;
      break;
    case 3:
      heading = <h3 className={tagClass}>{children}</h3>;
      break;
    case 4:
      heading = <h4 className={tagClass}>{children}</h4>;
      break;
    case 5:
      heading = <h5 className={tagClass}>{children}</h5>;
      break;
    case 6:
      heading = <h6 className={tagClass}>{children}</h6>;
      break;
    default:
      break;
  }

  return (
    <div className={`page-title ${className || ''}`}>
      <Col xs={12} md={12} lg={12} className="px-0 py-4 static-page-title">
        {heading}
      </Col>
    </div>
  );
};

export default PageTitle;
